import { useMemo } from "react";

const useLoginBackground = () => {
  return useMemo(
    () => ({
      backgroundImage: `url("${process.env.PUBLIC_URL || ""}/truck-bg.png")`,
    }),
    [],
  );
};

export default useLoginBackground;
